<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Coupon</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{name: 'Home'}">Home</router-link>
              </li>
              <li class="breadcrumb-item">
                <router-link :to="{name: 'CouponList'}">Coupons</router-link>
              </li>
              <li class="breadcrumb-item active">Coupon show</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="overlay" v-if="is_loading">
              <i class="fas fa-2x fa-sync-alt fa-spin"></i>
            </div>
            <div class="card-header">
              <h3 class="card-title">Detail</h3>
              <div class="card-tools">
                <router-link class="btn btn-info" :to="{name: 'CouponList'}">
                  <i class="fas fa-list"></i> List
                </router-link>
              </div>
            </div>
            <div class="card-body">
              <div class="custom-list">
                <ul>

                  <li><strong>ID</strong> {{ value.id }}</li>

                  <li><strong>Coupon Code</strong> {{ value.coupon_code }}</li>

                  <li><strong>Discount Value</strong> {{ value.discount_value }}</li>

                  <li><strong>Discount Type</strong> {{ value.discount_type }}</li>

                  <li><strong>Min Discount</strong> {{ value.min_discount }}</li>

                  <li><strong>Max Discount</strong> {{ value.max_discount }}</li>

                  <li><strong>Start Date</strong> {{ value.started_at }}</li>

                  <li><strong>End Date</strong> {{ value.ended_at }}</li>

                  <!--<li><strong>Maximum Usage</strong> {{ value.max_usage }}</li>-->

                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-header">
              <h3 class="card-title">Coupon usages</h3>
              <div class="card-tools">
                <button class="btn btn-info" @click="exportCouponDetail()">
                  <i class="fas fa-download"></i> Export
                </button>
              </div>
            </div>
            <!-- /.card-header -->
            <div class="card-body table-responsive p-0">
              <table class="table table-hover text-nowrap">
                <thead>
                <tr>
                  <th>Order ID</th>
                  <th>Invoice#</th>
                  <th>Username</th>
                  <th>Mobile</th>
                  <th>Email</th>
                  <th>Order price</th>
                  <th>Coupon amount (tk)</th>
                  <th>Order status</th>
                  <th>Ordered at</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(val, index) in value.orders.data">
                  <td>{{ val.id }}</td>
                  <td>{{ val.invoice_no }}</td>
                  <td v-if="val.is_guest === 0">{{ (val.buyer) ? val.buyer.username : 'NA' }}</td>
                  <td v-else>Guest User</td>
                  <td v-if="val.is_guest === 0">{{ (val.buyer) ? val.buyer.mobile_no : 'NA' }}</td>
                  <td v-else> --</td>
                  <td v-if="val.is_guest === 0">{{ (val.buyer) ? val.buyer.email : 'NA' }}</td>
                  <td v-else> --</td>
                  <td>{{ val.order_price | afterDecimal2 }}</td>
                  <td>{{ val.coupon_amount | afterDecimal2 }}</td>
                  <td>{{ val.order_status | orderStatus }}</td>
                  <td>{{ val.created_at | moment }}</td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="card-footer">
              <vue-pagination
                :pagination="value.orders"
                v-if="value.orders.total > value.orders.per_page"
                @paginate="initialize()"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

import VuePagination from "@/components/partials/PaginationComponent"
import axios from "axios"

const fileDownload = require("js-file-download")
import {Notification} from "element-ui"

export default {
  name: "CouponShow",
  metaInfo: {
    title: "Coupon detail | Dotlines"
  },
  components: {
    VuePagination
  },
  data: () => ({
    value: {
      coupon_usages: [],
      orders: {}
    },
    is_loading: false
  }),
  mounted: function () {
    this.initialize()
  },
  methods: {
    async initialize() {
      this.is_loading = true
      this.params = this.$route.params
      await this.getDetail(this.params.id).then(response => {
        this.value = response.data
      })
      this.is_loading = false
    },
    exportCouponDetail () {
      this.is_loading = true
      let coupon_id = this.$route.params.id
      axios.get('/coupons/'+ coupon_id + '/export', {
        params: {
          'coupon_id': coupon_id
        }, responseType: "blob",
      }).then((response) => {
        fileDownload(response.data, "coupon-reports.xlsx");
      }).catch((error) => {
        console.log("error " + error)
      }).finally(() => {
        this.is_loading = false
      })
    },
    getDetail: function (id) {
      let q = {...this.$route.query}
      return new Promise((resolve, reject) => {
        let api_url = "/coupons/" + id
        axios.get(api_url, {params: q}).then(response => {
          resolve(response)
        }).catch((error) => {
          console.log("error " + error)
          reject(error)
        })
      })
    },
  },
  filters: {
    moment: function (date) {
      return (typeof date !== "undefined") ?
        moment(date).format("MMMM Do YYYY, h:mm:ss a") : '--'
    },
    afterDecimal2(data) {
      return (typeof data !== "undefined") ? parseFloat(data).toFixed(2) : 0
    },
    orderStatus(data) {
      if (data === 1)
        return 'SUCCESS'
      if (data === 2)
        return 'PROCESSING'
      if (data === 3)
        return 'CANCELLED'
      if (data === 4)
        return 'FAILED'
    }
  },
}
</script>
